import { Component } from '@angular/core';

@Component({
    selector: 'sbw-popup2-demo',
    template: `<div class="component">
        <h2>Popup</h2>
        <sbw-button type="preferred" text="Open" (click)="open=true"></sbw-button>
        <sbw-popup2 heading="Some Header" *ngIf="open">
            <sbw-button type="preferred" text="Test" (click)="open=false"></sbw-button>
        </sbw-popup2>
    </div>`
})
export class Popup2DemoComponent {
    open = false
}
